<template>
    <div class="competitions">
        <div class="competitions-header">
            <h3>Spor Bahisleri</h3>
        </div>
        <div class="competitions-filter">
            <div class="e_active e_noCache ">
                <div class="nav_slider_txt">

                    <router-link :to="{ query: { page: $route.query.page, upcoming: 'today' } }" class="cursor" tag="div"
                                 exact-active-class="active" exact @click="$forceUpdate()"> Bugün
                    </router-link>
                    <router-link :to="{ query: { page: $route.query.page, upcoming: '3 hour' } }" class="cursor" tag="div"
                                 exact-active-class="active" exact> 3 saat
                    </router-link>
                    <router-link :to="{ query: { page: $route.query.page, upcoming: '24 hours' } }" class="cursor" tag="div"
                                 exact-active-class="active" exact> 24 saat
                    </router-link>
                    <router-link :to="{ query: { page: $route.query.page, upcoming: '48 hours' } }" class="cursor" tag="div"
                                 exact-active-class="active" exact> 2 gun
                    </router-link>
                    <router-link :to="{ name: 'Sportsbook', params: {sport: $route.params.sport} }" class="cursor" tag="div"
                                 exact-active-class="active" exact> Tumu
                    </router-link>

                </div>
                <div class="nav_slider">
                    <div id="slider" class="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all">
                        <div class="slider-box"
                        :class="$route.query.upcoming === 'today' ? 'wToday' :
                                $route.query.upcoming === '3 hour' ? 'w3Hour' :
                                $route.query.upcoming === '24 hours' ? 'w24Hours' :
                                $route.query.upcoming === '48 hours' ? 'w48Hours' : 'wAll'"></div>
                        <router-link :to="{ query: { page: $route.query.page, upcoming: 'today' } }" class="slider-box wToday o" tag="div"
                                     exact-active-class="active" exact>
                        </router-link>
                        <router-link :to="{ query: { page: $route.query.page, upcoming: '3 hour' } }" class="slider-box w3Hour o" tag="div"
                                     exact-active-class="active" exact>
                        </router-link>
                        <router-link :to="{ query: { page: $route.query.page, upcoming: '24 hours' } }" class="slider-box w24Hours o" tag="div"
                                     exact-active-class="active" exact>
                        </router-link>
                        <router-link :to="{ query: { page: $route.query.page, upcoming: '48 hours' } }" class="slider-box w48Hours o" tag="div"
                                     exact-active-class="active" exact>
                        </router-link>
                        <router-link :to="{ name: 'Sportsbook', params: {sport: $route.params.sport} }" class="slider-box wAll o" tag="div"
                                     exact-active-class="active" exact>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="onlive == 0">
            <ul v-for="s in sortAByKey(sport, 'order')" v-if="sport" class="competition-menu pre-list" :key="s.id">
                <li class="sport-collapse"
                    :class="s.sportId === $route.params.sport ? 'bg-blue' : ''"
                    v-on:click="collapse(s, 'sport')">
                    <span class="sport-icon ml-2">
                        <sportIcon :color="'#fff'" :sport="s.sportId"></sportIcon>
                    </span>
                    <span class="s_title">{{s.name}}</span>
                    <span class="event_couter">{{ s.eventCount }}</span>
                </li>
                <li class="sports" :id="'s_con_'+s.sportId" :style="(s.collapse || s.sportId == $route.params.sport) ? 'display: block' : 'display: none'">
                    <ul v-for="r in sortAByKey(sortAByKey(Object.values(s.region), 'order').splice(0, rSlice), 'order')"
                        :id="'s_con_'+s.sportId" :key="r.id">
                        <li class="region-selected">
                            <div @click="collapse(r, 'region', r)" style="height: 30px">
                                <span class="sport-icon ml-2" v-if="r.regionId === $route.params.region">
                                    <i class="ti-angle-double-down" style="font-size: 8px"></i>
                                </span>
                                <span class="sport-icon ml-2" v-else>»</span>
                                <span class="r_title">{{r.name | slimiter(34) }}</span>
                                <span class="event_couter">
									    {{ r.eventCount }}
								</span>
                            </div>

                            <ul :id="'r_con_'+r.regionId" :style="(r.collapse) ? 'display: block' : 'display: none'" class="competitions-list">
                                <li class="text-center">
                                    <router-link
                                            :to="{name: 'Sportsbook', params: {sport: s.sportId, region: r.regionId}, query: $route.query }">
                                        {{ t.betting.all }}
                                    </router-link>
                                </li>

                                <li v-for="c in sortByKey(r.competition, 'eventCount')" :key="c.id">
                                    <router-link
                                            :to="{name: 'Sportsbook', params: {sport: s.sportId, region: r.regionId, competition: c.competitionId}, query: $route.query }">
                                        <span class="sport-icon ml-2">
                                            <sportIcon color="#3e2950" :sport="s.sportId"></sportIcon>
                                        </span>
                                        <span>
                                            {{ c.name | slimiter(19) }}
                                        </span>
                                        <span class="event_couter">
											{{ c.eventCount }}
										</span>
                                    </router-link>
                                </li>


                            </ul>
                        </li>
                    </ul>
                    <ul>
                        <li class="region-selected" v-if="Object.values(s.region).length > 10"
                            @click="seeMoreRegion(Object.values(s.region).length)" style="height: 30px">
                            <span class="sport-icon ml-2">»</span>
                            <span class="r_title"
                                  v-text="rSlice === 10 ? 'daha fazla goster' : 'daha az goster'"></span>
                        </li>
                    </ul>
                </li>
            </ul>
        </template>
    </div>
</template>

<script>
    import sportIcon from '@/components/ui/asset/sportIcon';

    export default {
        name: 'CompetitionSide',
        components: {sportIcon},
        props: {
            onlive: {
                type: Number,
                default: 0
            },
            disableheaders: {
                type: Number,
                default: 0
            },
            item: {
                type: Number,
                default: 999999
            }
        },
        data() {
            return {
                w: window,
                t: this.$root.t,
                sport: false,
                rSlice: 10,
                clicked: [],
                sportType: [
                    {name: 'Sports', id: 1},
                    {name: 'eSports', id: 2}
                ],
                activeSportType: 1,
                firstMatch: null,
                sportCollapseList: [],
                regionCollapseList: [],
            }
        },

        watch: {
            '$route.query.upcoming'() {
                this.fetchCompetitions();
            },
        },
        destroyed() {
            if (this.onlive) {
                clearInterval(window.EventInterval);
                //clearInterval(window.EventCollapseInterval);
            }
        },
        mounted() {
            setTimeout(() => {
                this.collapse({sportId: this.$route.params.sport}, 'sport')
            }, 1000);

            this.fetchCompetitions();

            this.viewport = (this.$route.query.view) ? this.$route.query.view : this.viewport;

        },
        methods: {
            seeMoreRegion(data) {
                if (this.rSlice !== 10) {
                    this.rSlice = 10
                } else {
                    this.rSlice = data
                }
            },
            collapseInit() {
                if (this.sportCollapseList) {
                    this.sportCollapseList.forEach(function (entry, k) {
                        if (typeof entry !== 'undefined') {
                            var x = document.getElementById('s_con_' + k);
                            if (entry) {
                                x.style.display = "block";
                            } else {
                                x.style.display = "none";
                            }
                        }
                    });
                }

                if (this.regionCollapseList) {
                    this.regionCollapseList.forEach(function (entry, k) {

                        if (typeof entry !== 'undefined') {
                            var xc = document.getElementById('r_action_' + k);
                            var x = document.getElementById('r_con_' + k);
                            if (entry) {
                                x.style.display = "block";
                                //xc.innerHTML = '<span class="when-opened"><i class="os-icon os-icon-minus-circle"></i></span>'
                            } else {
                                x.style.display = "none";
                                //xc.innerHTML = '<span class="when-opened"><i class="os-icon os-icon-plus-circle"></i></span>'
                            }
                        }


                    });
                }

            },
            isClollapsed(s) {
                return this.sportCollapseList[s.sportId];
            },
            collapse(s, mode = 'sport', r) {

                s.collapse = (s.collapse) ? false : true;

                /*

                if (mode == 'sport') {
                    if (this.sportCollapseList[s.sportId]) {
                        this.sportCollapseList[s.sportId] = false
                    } else {
                        this.sportCollapseList[s.sportId] = true
                    }
                } else {
                    if (this.regionCollapseList[s.sportId+s.regionId]) {
                        this.regionCollapseList[s.sportId+s.regionId] = false
                    } else {
                        this.regionCollapseList[s.sportId+s.regionId] = true
                    }
                }

                this.collapseInit(); */
            },

            async fetchCompetitions() {

                var th = this;

                th.activeSportType = th.$route.params.sport;

                this.$http.get(bsapi + 'matches.aspx?_=dynamic', {
                    params: {
                        app: this.$root.app.id,
                        withoutMatch: (this.onlive) ? 0 : 1,
                        onLive: this.onlive,
                        upcoming: this.$route.query.upcoming,
                        per_page: this.item
                    }
                }).then(response => {
                    // get body data

                    th.sport = response.body.result.sport;

                    var vats = Object.values(th.sport);

                    var t = new Date();
                    t.setSeconds(t.getSeconds() + 60);

                    //window.currentEvents.data = vats;
                    //window.currentEvents.time = t.getSeconds();

                    if (th.item === 999999) {
                        th.$bus.$emit('FixtureEvents', th.sport);
                    }

                }, response => {
                    th.$bus.$emit('FixtureEvents', null);
                })
            },

            selectSport(sport) {
                return (sport) ? 2 : 1;
            },
            setSport(sport) {
                this.activeSportType = sport;
            },
            setMatch(match) {
                this.$bus.$emit('selectedMatch', match);
            },
            checkSport(sportId) {
                if (this.activeSportType == 0 && this.onlive) {
                    return true;
                }
                return (sportId == this.activeSportType) ? true : false;
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    . competitions {
        font-family: 'Roboto', Helvetica, Arial, sans-serif !important;
    }

    .disable-header .element-header, .disable-header .element-actions, .disable-header .region-title, .disable-header .selected {
        display: none
    }

    .disable-header .element-wrapper {
        padding-bottom: 0px !important;
    }

    .score {
    }

    .minute_counter {
        font-weight: normal !important;
    }

    .element-header {
        color: #fff;
        text-shadow: none;
    }

    .sport-icon {
        width: 15px;
        height: 15px;
        float: left;
        margin: 2px 10px 5px 0px;
        text-align: center;
    }

    .r_title {
        display: inline-block;
        width: 110px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .tabs-style-topline nav a span {
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 700;
        font-size: 0.9em;
    }

    .competitions-header {
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 3px solid #fff;
        min-height: 30px;
    }

    .competitions-header h3 {
        font-size: 15px;
        color: #fff;
        line-height: 35px;
        font-weight: 400;
        font-family: 'Roboto', Helvetica, Arial, sans-serif !important;
        margin: 0;
    }

    .competition-menu, .live-competition-menu {
        padding: 0;
        margin: 0;
        border-left: 1px solid rgba(40, 44, 42, 0.1);
        border-right: 1px solid rgba(40, 44, 42, 0.1);
        width: 100%;
        position: relative;
    }

    .competition-menu ul, .live-competition-menu ul {
        padding: 0px;
    }

    .competition-menu li, .live-competition-menu li {
        font-size: 11px;
        list-style: none;
        line-height: 28px;
        display: block;
        cursor: pointer;
    }

    .competition-menu li:hover .s_title {
        color: #f64835;
    }

    .competition-menu li.team-block {
        list-style: none;
        display: contents;
        float: left;
        width: 100%;
        background: #fff;
        border-bottom: 2px solid #ccc;
    }

    .competition-menu li ul {
        color: #818ba7;
    }

    .competition-menu li a {
        color: #000;
        display: block;
        overflow: hidden;
        background: #fff;
        border-bottom: 1px solid #cccccc;
        width: 100%;
    }

    .competition-menu li a:hover {
        color: #f64835;
    }

    .competitions-list {
        background: #565555
    }

    .competitions-list li {
        background: #eff3f3
    }

    .live-competition-menu li {
        line-height: 20px;
        padding: 5px 5px;
    }

    .competition-menu a {
        cursor: pointer;
    }

    .competition-menu .selected {
        font-weight: bold;
        color: #2CC185;
    }

    .competition-menu .selected li {
        background: transparent;
    }

    .competition-menu .region-selected {
        color: #000;
        background: #e8e8e8;
        border-bottom: 1px solid #d9d9d9;
        font-weight: 400;
        display: flow-root;
    }

    .competition-menu .region-selected .sport-icon {
        width: 15px;
        height: 15px;
        float: left;
        margin: 0 10px 5px 0;
        text-align: center;
        font-size: 15px;
        font-weight: lighter;
    }

    .team-block:hover, .team-block.selected {
        background: #003366 !important;
    }

    .team-block.selected a {
        background: #003366;
    }

    .team-block:hover a, .team-block.selected a {
        color: #fff !important;
    }

    .region-selection span.when-opened {
        margin-right: 9px;
    }

    .competition-menu .competition-selected {
        margin: 0;
        padding: 0;
    }

    .competition-menu .competition-selected a {
        color: #fff !important;
    }

    .team-block .teams {
        font-weight: bold;
    }

    .competition-title {
        padding: 0 25px;
        font-size: 11px;
    }

    .region-title {
        border-bottom: 3px solid #2CC185;
    / / background: #3e2950 !important;
        font-weight: bold;
        padding: 0 5px;
        color: #05f0ff;
        float: left;
        width: 100%;
    }

    .sport-collapse {
        color: #fff;
        border-bottom: 2px solid #373737 !important;
        position: relative;
    }

    .sport-collapse:first-child {
        border-top: 1px solid #373737 !important;
    }

    .sport-collapse:before {
        content: "";
        position: absolute;
        top: -.1rem;
        left: 0rem;
        right: 0rem;
        height: 0px;
        background: #10548e;
    }

    .event_couter {
        float: right;
        font-size: 11px;
        white-space: nowrap;
        text-align: right;
        background: #373737;
        height: 20px;
        padding: 0 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 5px;
        border: 1px solid #173047;
        position: relative;
    }

    .element-actions {
        font-size: 11px;
        white-space: nowrap;
        text-align: right;
        color: #fff;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 5px;
        margin: 5px;
        z-index: 100;
    }

    .event_couter:before {
        content: "";
        position: absolute;
        width: 105%;
        height: 21px;
        border: 1px solid #173049;
    }

    .event_couter span {
        width: 14px !important;
        overflow: hidden;
    }

    .competition-menu .region-selected .event_couter {
        background: #c0c0c0;
        border: 1px solid #929292 !important;
        color: #fff;
    }

    .competition-menu .region-selected .event_couter:before {
        border-left: 1px solid #7f7f7f;
        border-top: 1px solid #7f7f7f;
        border-bottom: none;
        border-right: none;
        height: 19px;
        display: none;
    }

    .nav-item {
        flex: 0 0 22% !important;
    }

    .time-toolbar {
        padding: 0 !important;
        margin: 0 !important;
    }

    .competitions {
        background: #7c7c7c;
        border-bottom: 1px solid #737373;
    }

    .competitions-list .event_couter {
        background: #fff !important;
        color: #666666 !important;
        font-weight: 600;
    }

    .nav_slider_txt {
        width: 195px;
        height: 16px;
        margin-top: 8px;
        margin-left: 10px;
    }

    .nav_slider_txt div {
        float: left;
        width: 36px;
        font-size: 9px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
    }

    .nav_slider {
        width: 195px;
        height: 14px;
        background: url(../../../static/assets/img/nav/nav_slider_bg-7E75370010D7F45217CEF1AD5957E72B.png) 50% 0 no-repeat;
        padding-top: 7px;
        margin-bottom: 10px;
    }

    #slider {
        position: relative;
        width: 140px;
        height: 10px;
        margin-left: 27px;
    }

    .slider-box {
        position: absolute;
        height: 10px;
        width: 10px;
        background: #f64835;
    }

    .slider-box.o {
        opacity: 0;
    }

    .slider-box.wToday {
        left: -5px;
    }
    .slider-box.w3Hour {
        left: 30px;
    }
    .slider-box.w24Hours {
        left: 65px;
    }
    .slider-box.w48Hours {
        left: 100px;
    }
    .slider-box.wAll {
        left: 135px;
    }
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/CompetitionSide.vue